import React, {Component} from 'react';
import {getPeople, insertOrUpdatePeople, getAllTimeZones, getAllSkill} from '../../util/APIUtils';
import {SESSION_USER,API_BASE_URL} from '../../constants';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import Loading from '../../common/Loading';
import $ from 'jquery';
import 'dropify';
import 'dropify/dist/css/dropify.css';
import 'jquery-asColorPicker';

//import 'jquery-asColorPicker/dist/css/asColorPicker.css';

import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField, textAreaField} from '../../helpers/Error';

import { ToastContainer ,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CreatableSelect from "react-select/lib/Creatable";


const validate = (values, props) => {
    const errors = {};
    if (!values.firstName) {
        errors.firstName = 'FirstName field required'
    }
    if (!values.lastName) {
        errors.lastName = 'LastName field required'
    }
    if (!values.rolename) {
        errors.rolename = 'Role field required'
    }
    if (!values.address) {
        errors.address = 'Address field required'
    }
    if (!values.workingfromtime || !values.workingtotime) {
        errors.workingtotime = ' Working Time required'
    }
    if (!values.email) {
        errors.email = 'Email field required'
    } else if (values.email) {
        //errors.email = 'You have entered an invalid email address'
        var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(values.email)) {
            errors.email = 'Invalid email address'
        }
    } else if (values.email) {
        let emailExist = false;
        // checkEmailAvailability(values.email)
        //     .then(response => {
        //         if (response.available !== true) {
        //             emailExist = true;
        //         }
        //     }).catch(error => {
        //     if (error.status === 404) {
        //         emailExist = false;
        //     } else {
        //         emailExist = false;
        //     }
        // });
        if (!emailExist) {
            //errors.email = 'Email address already exist'
        }
    }
    if (!values.ssopassword) {
        errors.ssopassword = 'Password field required'
    }
    else if (!/^.*(?=.{3,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\d\X])(?=.*[!@#$%^&*\(\)]).*$/.test(values.ssopassword)) {
        errors.ssopassword = 'Password must contain numbers (0-9), alphanumeric & special character (!@#$&*^%)")'
    }else if(values.ssopassword.length < 4){
        errors.ssopassword = 'Password must be enter minimum 4 character'
    }
    if (!values.confirmssopassword) {
        errors.confirmssopassword = 'Confirm password field required'
    }
    else if (values.ssopassword != values.confirmssopassword) {
        errors.confirmssopassword = 'Password and confirm password must be same'
    }
   // console.log('values.timezone', values.timezone);
    if (!values.timezone) {
        errors.timezone = 'Timezone field required'
    }
   /* if (!values.appId) {
        errors.appId = 'AppId field required'
    }*/
    if (values.skills.length == 0) {
        errors.skills = 'Skill field required'
    }
    return errors;
};


const userrole = [
  {
    "label": "User",
    "value": "ROLE_USER"
  },
  {
    "label": "Admin",
    "value": "ROLE_ADMIN"
  }
];

const overrideshiftoption = [
  {
    "label": "Yes",
    "value": "1"
  },
  {
    "label": "No",
    "value": "0"
  }
];


class peoForm extends React.Component {


    constructor(props) {
        super(props);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <input type="hidden" name="id" id="id" value={this.props.states.id}/>
               
                <div className="form-body">
                    <div className="row p-t-20">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">First Name </label>
                                <Field type="text" className="form-control" name="firstName"
                                       fieldValue={this.props.states.firstName}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Last Name</label>
                                <Field type="text" className="form-control" name="lastName"
                                       fieldValue={this.props.states.lastName}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                         <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Role </label>
                                {/*<Field valueKey="value" options={userrole}*/}
                                       {/*value={this.props.states.rolename} name="rolename"*/}
                                       {/*component={selectField}*/}
                                       {/*onChange={this.props.roleSelectChange}/>*/}
                                <CreatableSelect
                                    name="rolename"
                                    defaultValue={this.props.states.rolename}
                                    onChange={this.props.roleSelectChange}
                                    options={userrole}
                                    value={this.props.states.rolename}
                                />
                                <Field type="hidden" className="form-control" name="rolename"
                                       fieldValue={this.props.states.rolename}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Email</label>
                                <Field type="text" className="form-control" name="email"
                                       fieldValue={this.props.states.email}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>

                     <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Password</label>
                                <Field type="password" className="form-control" name="ssopassword"
                                       fieldValue={this.props.states.ssopassword}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Confirm Password</label>
                                <Field type="password" className="form-control" name="confirmssopassword"
                                       fieldValue={this.props.states.confirmssopassword}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>

                   

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Address</label>
                                <Field rows="2" cols="24" component={textAreaField} name="address"
                                       className='form-control' id="address" value={this.props.states.address}
                                       onChange={this.props.handleChange}/>

                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Biography</label>
                                <Field rows="2" cols="24" component={textAreaField} name="biography"
                                       className='form-control' id="biography" value={this.props.states.biography}
                                       onChange={this.props.handleChange}/>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <UploadForm onFileChange={this.props.changeFile} profileLogo={this.props.states.profileLogo}  peopleId={this.props.states.id}/>
                        </div>

                    </div>


                    <h3 className="box-title m-t-40">Employee Feature</h3>
                    <hr/>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Timezone </label>
                                {/*<Field valueKey="value" options={this.props.states.optionTimezoneList}*/}
                                       {/*value={this.props.states.timezone} name="timezone"*/}
                                       {/*component={selectField}*/}
                                       {/*onChange={this.props.selectChange}/>*/}

                                <CreatableSelect
                                    name="timezone"
                                    defaultValue={this.props.states.timezone}
                                    onChange={this.props.selectChange}
                                    options={this.props.states.optionTimezoneList}
                                    value={this.props.states.timezone}
                                />
                                <Field type="hidden" className="form-control" name="timezone"
                                       fieldValue={this.props.states.timezone}
                                       component={inputField}
                                       onChange={this.props.changeState}/>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Zoho Id</label>
                                <Field type="text" className="form-control" name="zohoId"
                                       fieldValue={this.props.states.zohoId}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                          <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Status</label>

                                <Field type="number" className="form-control" name="status"
                                       fieldValue={this.props.states.status}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Over Right Shift Time</label>
                               

                                         <CreatableSelect
                                    name="overRideShiftTime"
                                    defaultValue={this.props.states.overRideShiftTime}
                                    onChange={this.props.overideShiftChange}
                                    options={overrideshiftoption}
                                    value={this.props.states.overRideShiftTime}
                                     />

                                      <Field type="hidden" className="form-control" name="overRideShiftTime"
                                       fieldValue={this.props.states.overRideShiftTime}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Event background color </label>
                                <Field type="text" className="colorpicker form-control" name="bgcolor" id="bgcolor"
                                       fieldValue={this.props.states.bgcolor}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Event text color</label>
                                <Field type="text" className="colorpicker form-control" name="textcolor" id="textcolor"
                                       fieldValue={this.props.states.textcolor}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Skills </label>
                                {/*<Field valueKey="value" options={this.props.states.optionSkillList}*/}
                                       {/*value={this.props.states.skills} id="skills" name="skills" isMulti*/}
                                       {/*component={selectField}*/}
                                       {/*onChange={this.props.selectSkillChange}/>*/}
                                <CreatableSelect
                                    name="skills"
                                    isMulti
                                    onChange={this.props.selectSkillChange}
                                    options={this.props.states.optionSkillList}
                                    value={this.props.states.skills}
                                />
                                <Field type="hidden" className="form-control" name="skills" id="skills"
                                       fieldValue={this.props.states.skills}
                                       component={inputField}/>
                            </div>
                        </div>

                         <div className="col-md-6">
                         <label className="control-label">Employee Job Time (24 hours format)</label>
                                    <div>
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="workingfromtime" name="workingfromtime"
                                               fieldValue={this.props.states.workingfromtime}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="workingtotime" name="workingtotime"
                                               fieldValue={this.props.states.workingtotime}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>
                     </div>
                   

                    </div>
                    <h3 className="box-title m-t-40">Employee Working Time</h3>
                    <hr/>


                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Monday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="monday_start_time" name="monday_start_time"
                                               fieldValue={this.props.states.monday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="monday_end_time" name="monday_end_time"
                                               fieldValue={this.props.states.monday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Tuesday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="tuesday_start_time" name="tuesday_start_time"
                                               fieldValue={this.props.states.tuesday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="tuesday_end_time" name="tuesday_end_time"
                                               fieldValue={this.props.states.tuesday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Wednesday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="wednesday_start_time" name="wednesday_start_time"
                                               fieldValue={this.props.states.wednesday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                           <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="wednesday_end_time" name="wednesday_end_time"
                                               fieldValue={this.props.states.wednesday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Thursday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="thursday_start_time" name="thursday_start_time"
                                               fieldValue={this.props.states.thursday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="thursday_end_time" name="thursday_end_time"
                                               fieldValue={this.props.states.thursday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Friday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="friday_start_time" name="friday_start_time"
                                               fieldValue={this.props.states.friday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="friday_end_time" name="friday_end_time"
                                               fieldValue={this.props.states.friday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Saturday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="saturday_start_time" name="saturday_start_time"
                                               fieldValue={this.props.states.saturday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="saturday_end_time" name="saturday_end_time"
                                               fieldValue={this.props.states.saturday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Sunday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="sunday_start_time" name="sunday_start_time"
                                               fieldValue={this.props.states.sunday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="sunday_end_time" name="sunday_end_time"
                                               fieldValue={this.props.states.sunday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>


                      <div className="row">

                     </div>
                  <br/>
                </div>
                
                <div className="form-actions">
                    <button type="submit" className="btn btn-primary btn-rounded"><i className="fa fa-check"></i> Save</button>
                    &nbsp;&nbsp;&nbsp;
                    <a href="/peoples" className="btn btn-inverse btn-rounded">Cancel</a>
                </div>
            </form>
        );
    }
}

const PeoForm = reduxForm({
    form: 'peo_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    destroyOnUnmount: false,
    validate
})(peoForm);


//import {jQuery} from 'jquery';
//import 'jquery-ui-dist/jquery-ui';
//import 'bootstrap';
//import 'bootstrap-colorpicker';


class PeopleForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            ssopassword:'',
            confirmssopassword:'',
            email: '',
            timezone: '',
            appId: '',
            status:'1',
            overRideShiftTime:'0',
            zohoId: '',
            bgcolor: '#54555e',
            textcolor: '#e5e7f5',
            address: '',
            biography: '',
            id: '',
            loading: true,
            file:'',
            profileLogo:'',
            rolename:'',
            workingfromtime:'09:00',
            workingtotime:'18:00',

            monday_start_time:'09:00',
            monday_end_time:'18:00',
            tuesday_start_time:'09:00',
            tuesday_end_time:'18:00',
            wednesday_start_time:'09:00',
            wednesday_end_time:'18:00',
            thursday_start_time:'09:00',
            thursday_end_time:'18:00',
            friday_start_time:'09:00',
            friday_end_time:'18:00',
            saturday_start_time:'09:00',
            saturday_end_time:'18:00',
            sunday_start_time:'09:00',
            sunday_end_time:'18:00',

            optionTimezoneList: [],
            optionSkillList: [],
            skills: []
        }
        this.loadpeople = this.loadpeople.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.timezonelist = this.timezonelist.bind(this);
        this.skilllist = this.skilllist.bind(this);
        this.changeFile= this.changeFile.bind(this);
        this.onRoleSelectChange = this.onRoleSelectChange.bind(this);
        this.isStartTimeNull= this.isStartTimeNull.bind(this);
        this.isEndTimeNull= this.isEndTimeNull.bind(this);
        this.onOverideShiftChange = this.onOverideShiftChange.bind(this);
    }

    isStartTimeNull(weekHours,dayOfweek){
         if(weekHours && weekHours[dayOfweek]){
            return weekHours[dayOfweek].start_time;
         }
         return '08:00'; 
    }


    isEndTimeNull(weekHours,dayOfweek){
         if(weekHours && weekHours[dayOfweek]){
            return weekHours[dayOfweek].end_time;
         }
         return '18:00'; 
    }

    skilllist() {
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        getAllSkill(user.id)
            .then(response => {
                var skillarray = [];
                for (var k in response) {
                    skillarray.push({label: response[k].name, value: response[k].id})
                }
                this.setState({optionSkillList: skillarray});
                //console.log(skillarray);

            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
    }

    timezonelist() {

        getAllTimeZones()
            .then(response => {
                var timzonearray = [];
                for (var k in response) {
                    timzonearray.push({label: response[k], value: response[k]})
                }
                this.setState({optionTimezoneList: timzonearray});

                //console.log(timzonearray);
            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
    }

    componentDidMount() {
        const peopleId = this.props.match.params.peopleId;
        if (peopleId > 0) {
            this.loadpeople(peopleId);
        } else {

            this.setState({loading: false});
        }
        this.timezonelist();
        this.skilllist();


        // $('.demo1').colorpicker();

    }

    componentDidUpdate(nextProps) {
        if (this.props.match.params.peopleId !== nextProps.match.params.peopleId) {
            this.loadpeople(nextProps.match.params.peopleId);
        }
    }

    changeFile(e) {
           this.setState({file: e.target.files[0]});
    }

    handleChange(event) {
        const target = event.target;
        const inputValue = target.value;
        this.setState({
            [target.name]: inputValue
        });
    }

    onSelectChange(value) {
        const target = value;
       // console.log(target);
        if (!this.state.loading) {
            this.setState({timezone: target});
        }

    }

     onRoleSelectChange(value) {
        const target = value;
       // console.log(target);
        if (!this.state.loading) {
            this.setState({rolename: target});
        }

    }

   onOverideShiftChange(value) {
        const target = value;
       // console.log(target);
        if (!this.state.loading) {
            this.setState({overRideShiftTime: target});
        }

    }

  

    onSelectSkillChange(value) {
        const target = value;
        console.log(target);
        if (!this.state.loading) {
            this.setState({skills: target});
        }

    }

    loadpeople(peopleId) {

        getPeople(peopleId)
            .then(response => {

                var selectedskills = [];
                if (response.skills) {
                    for (var k in response.skills) {
                        var skill = response.skills[k];
                        if (skill.isDeleted == 1)continue;
                        var selectedSkill = {value: skill.id, label: skill.name};
                        selectedskills.push(selectedSkill);
                    }
                }

                var selectedRole={};
                if(response.roles){
                    var selectedRole=response.roles[0];
                    for(var k in userrole){
                      var role= userrole[k];
                      if(selectedRole){
                        if(role.value==selectedRole.name){
                          selectedRole=role;    
                      }
                      }
                      
                    }
                    console.log(selectedRole);
                   
                }
                   var selectedOverideShift={};
                    for(var k in overrideshiftoption){
                        var data= overrideshiftoption[k];
                        console.log(data);
                        if(response.overRideShiftTime==data.value){
                             selectedOverideShift=data;    
                          }
                    }
                      
                


                this.setState({
                    firstName: response.firstName,
                    lastName: response.lastName,
                    ssopassword:response.ssopassword,
                    confirmssopassword:response.ssopassword,
                    email: response.email,
                    timezone: {label: response.timezone, value: response.timezone},
                    rolename:selectedRole,
                    zohoId: response.zohoId,
                    status:response.status,
                    textcolor: response.textcolor,
                    bgcolor: response.bgcolor,
                    biography: response.biography,
                    address: response.address,
                    workingfromtime:response.workingfromtime,
                    workingtotime:response.workingtotime,
                    id: response.id,
                    profileLogo:response.profileLogo,
                    skills: selectedskills,
                    overRideShiftTime:selectedOverideShift,

                    monday_start_time:this.isStartTimeNull(response.weekHours,1),
                    monday_end_time:this.isEndTimeNull(response.weekHours,1),
                    tuesday_start_time:this.isStartTimeNull(response.weekHours,2),
                    tuesday_end_time:this.isEndTimeNull(response.weekHours,2),
                    wednesday_start_time:this.isStartTimeNull(response.weekHours,3),
                    wednesday_end_time:this.isEndTimeNull(response.weekHours,3),
                    thursday_start_time:this.isStartTimeNull(response.weekHours,4),
                    thursday_end_time:this.isEndTimeNull(response.weekHours,4),
                    friday_start_time:this.isStartTimeNull(response.weekHours,5),
                    friday_end_time:this.isEndTimeNull(response.weekHours,5),
                    saturday_start_time:this.isStartTimeNull(response.weekHours,6),
                    saturday_end_time:this.isEndTimeNull(response.weekHours,6),
                    sunday_start_time:this.isStartTimeNull(response.weekHours,0),
                    sunday_end_time:this.isEndTimeNull(response.weekHours,0),
                    
                    loading: false
                });
            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
    }

    handleSubmit(values, dispatch) {
        //event.preventDefault();
        //console.log(this.state);
        const fields = values;
         console.log(fields);
     //   return false;
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        fields["userId"] = user.id;
        if (fields['timezone']) {
            fields['timezone'] = fields['timezone'].value;
        }
        if (fields['rolename']) {
            fields['rolename'] = fields['rolename'].value;
        }
        if (fields['overRideShiftTime']) {
            fields['overRideShiftTime'] = fields['overRideShiftTime'].value;
        }
        if (fields['skills']) {
            var skillarray = [];
            var skills = fields['skills'];
            if(skills !== undefined && skills !== ''){
                for (var k in skills) {
                    console.log(skills[k]);
                    skillarray.push(skills[k].value);
                }
                fields['skills'] = skillarray;
            }
        }

       
        fields['bgcolor']= $('#bgcolor').val();
        fields['textcolor']= $('#textcolor').val();


        console.log(fields);
    // return false;
     const formData = new FormData();
    
      if(fields){
        for(var k in fields){
           var field= fields[k];
            formData.append(k,field);
        }
      }

      if(this.state.file){
         formData.append('file',this.state.file);
      }else{
         formData.delete('file');
      }

      //console.log('fields', formData);

       //return false;
        insertOrUpdatePeople(formData)
            .then(response => {
                console.log(response);
                if(response.success==false){
                    toast.error(response.message+"!", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    return false;
                }
                this.props.history.push("/peoples");
            }).catch(error => {
            this.setState({
                serverError: true,
            });
        })


    }


    render() {

        let $this = this;

        if (this.state.notFound) {
            return <NotFound />;
        }

        if (this.state.serverError) {
            return <ServerError />;
        }

        if (this.state.loading) {
            //return 'Loading...'
            return <Loading />;
        }



        return (
            <div>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor m-b-0 m-t-0">Employee Form</h3>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="">Home</a></li>
                            <li className="breadcrumb-item active">Employee</li>
                        </ol>
                    </div>
                    <div className="col-md-7 col-4 align-self-center">
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-outline-info">
                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Employee form</h4>
                            </div>
                            <div className="card-body">
                                <Provider store={Store}>
                                    <PeoForm changeState={$this.handleChange} states={$this.state}
                                             initialValues={$this.state} selectChange={$this.onSelectChange}
                                             roleSelectChange={$this.onRoleSelectChange}
                                             overideShiftChange={$this.onOverideShiftChange}
                                             
                                             selectSkillChange={$this.onSelectSkillChange.bind(this)}
                                             changeFile={this.changeFile}
                                             onSubmit={$this.handleSubmit.bind($this)}/>
                                </Provider>
                                <ToastContainer
                                    position="top-right"
                                    autoClose={5000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    pauseOnHover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default PeopleForm;

class UploadForm extends Component {
    componentDidMount() {
        $('.dropify').dropify();
        $(".colorpicker").asColorPicker( {mode: 'simple'});
        $('#basicExample .time1').timepicker({
            showDuration: true,
            template : false,
            showInputs : false,
            minuteStep : 5,
           // timeFormat: 'g:i A'
              timeFormat: 'G:i',
             show2400: true,
        });
    }

    render() {
     const profileLogo = this.props.profileLogo;
      var peopleId=this.props.peopleId;
      var filePath='../static/assets/images/people.png'; 
       if(profileLogo){
           filePath=API_BASE_URL+'/image/people/'+peopleId+'/profileimage.jpg';
       }
        return (

            <div className="form-group">

                <label htmlFor="input-file-now-custom-1">Profile Image</label>
                <small className="form-control-feedback">
                    <a className="mytooltip" href="javascript:void(0)"><i className="fa fa-info-circle"></i><span
                        className="tooltip-content5"><span className="tooltip-text3"><span className="tooltip-inner2">Profile Picture: <br/>180 x 180 pixels </span></span></span></a>
                </small>

                <input type="file" onChange={this.props.onFileChange} id="input-file-now-custom-1" accept="image/*" name="file" className="dropify"
                       data-height="75" data-max-file-size="1M" data-default-file={filePath}/>


            </div>

        );
    }

}